import { routesSetting } from "@/router";
import { useTranslation } from "react-i18next";
import { HiLink, HiOutlineLink, HiOutlineSquare3Stack3D, HiSquare3Stack3D } from "react-icons/hi2";

import SettingsSidebarLinkItem from "@/components/atoms/SettingsSidebarLinkItem";

const Sidebar = () => {
  const { t } = useTranslation();

  return (
    <div className={"h-screen w-full max-w-72 shrink-0 border-r border-secondary px-4 py-5"}>
      <div className={"flex flex-col gap-x-2 gap-y-2"}>
        <h3 className={"mb-3 text-2xl font-semibold text-primary"}>{t("settings.sidebar.settings")}</h3>
        <SettingsSidebarLinkItem
          label={t("settings.sidebar.plansBilling")}
          activeIcon={HiSquare3Stack3D}
          inactiveIcon={HiOutlineSquare3Stack3D}
          link={routesSetting.plans}
        />
        <SettingsSidebarLinkItem
          label={t("settings.sidebar.crmConnections")}
          activeIcon={HiLink}
          inactiveIcon={HiOutlineLink}
          link={routesSetting.crm}
        />
      </div>
    </div>
  );
};

export default Sidebar;
